<template>
  

    <CModal
    v-model="show" 
    title="Edit Asset"
    :tag="false"
    :progressing="loading"
    @hide='hide'
    :size="'lg'"
     centered
      >   
      <b-container class="ml-4 mb-4">
        <b-row class="d-flex flex-row justify-content-start mb-2">
          <b-button class="asset-type-btn" v-if="assetType === 'Menu Display'" variant="warning">Menu Display</b-button>
        </b-row>
        <b-row class="d-flex flex-row justify-content-start mb-2" :style="{'gap':'0.4rem'}">
          
          <b-button class="asset-type-btn" v-if="assetType === 'Self-Ordering Kiosk'" variant="warning">Self-Ordering Kiosk</b-button>
  
          <b-button class="asset-type-btn" v-if="assetType === 'Thermal Printer'" variant="warning">Thermal Printer</b-button>
  
          <b-button class="asset-type-btn" v-if="assetType === 'Card Reader'" variant="warning">Card Reader</b-button>
  
        </b-row>
        <b-row class="d-flex flex-row justify-content-start ">
          <b-button class="asset-type-btn" v-if="assetType === 'Kitchen Display (KDS)'" variant="warning">Kitchen Display (KDS)</b-button>
  
        </b-row>
        <b-row class="d-flex flex-row justify-content-start ">
          <b-button class="asset-type-btn" v-if="assetType === 'POS Terminal Display'" variant="warning">POS Terminal Display</b-button>
  
        </b-row>
      </b-container>
      <b-row v-if="err != ''" class="d-flex flex-row justify-content-center" ><p :style="{color: 'red', 'font-size': '1rem'}" class="text-center">{{ err }}</p> </b-row>
  
      <b-container v-if="assetType === 'Menu Display' || assetType === 'POS Terminal Display' || assetType === 'Kitchen Display (KDS)' ">
        <b-input-group  prepend="Asset Name">
          <b-form-input class="" type="text" name="Asset Name" placeholder="Required" v-validate="'required'" v-model="assetName"/>
        </b-input-group>
      </b-container>
      
      <b-container v-if=" assetType === 'Self-Ordering Kiosk' ">
        <b-row>
          <b-input-group  prepend="Asset Name">
            <b-form-input class="" type="text" name="Asset Name" placeholder="Required" v-validate="'required'" v-model="assetName"/>
          </b-input-group>
        </b-row>
        <b-row class="d-flex justify-content-center mt-4">
          <h6>This asset is linked to the following:</h6>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12" md="6" class="d-flex justify-content-center justify-content-md-end mr-md-4 mb-4 mb-md-0">
            <b-form-group>
            <p class="text-center" v-if="(!deletedPrinterLink && selectedPrinter!= null) || loading">Thermal Printer <br/> <b-button @click="printerSelectNone()" variant="outline-warning m-2" size="medium">None</b-button></p>
            <p class="text-center" v-else>Thermal Printer <br/> <b-button variant="warning m-2" size="medium">None</b-button></p>
              <b-form-radio-group
                    id="btn-radios-2"
                    v-model="selectedPrinter"
                    :options="thermalPrinters"
                    button-variant="outline-warning"
                    size="md"
                    name="radio-btn-outline"
                    buttons
                    :style="{'gap': '1rem !important'}"
                    class="d-flex flex-column mt-1"
                    @change="printerLinkChanged()"
                ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="d-flex justify-content-center justify-content-md-start">

            <b-form-group>
            <p class="text-center mb-3" v-if="(!deletedReaderLink && selectedReader != null) || loading">Card Reader <br/> <b-button @click="readerSelectNone()" variant="outline-warning m-2" size="medium">None</b-button></p>
            <p class="text-center mb-3" v-else>Card Reader <br/> <b-button variant="warning m-2" size="medium">None</b-button></p>
            

                <b-form-radio-group
                      id="btn-radios-2"
                      v-model="selectedReader"
                      :options="cardReaders"
                      button-variant="outline-warning"
                      size="md"
                      name="radio-btn-outline"
                      buttons
                      :style="{'gap': '1rem !important'}"
                      class="d-flex flex-column mt-1"
                      @change="readerLinkChanged()"
                  ></b-form-radio-group>
            </b-form-group>
          </b-col>

        </b-row>
      </b-container>

  
      <b-container v-if="assetType=== 'Thermal Printer'">
  
          <b-input-group prepend="Asset Name" class="mb-3">
            <b-form-input class="" type="text" name="Asset Name" placeholder="Required" v-validate="'required'" v-model="assetName"/>
          </b-input-group>
  
          <b-row class="d-flex flex-row justify-content-start ml-2" :style="{gap:'0.4rem'}">
            <p class="pt-2">Used for:</p>
            
            <b-button class="printer-type-btn" variant="warning" v-if="printerType === 'Order Ticket'">Order Ticket</b-button>
            <b-button class="printer-type-btn" @click="changePrinterType('Order Ticket')" variant="outline-primary" v-else>Order Ticket</b-button>
  
            <b-button class="printer-type-btn" variant="warning" v-if="printerType === 'Customer Receipt'">Customer Receipt</b-button>
            <b-button class="printer-type-btn" @click="changePrinterType('Customer Receipt')" variant="outline-primary" v-else>Customer Receipt</b-button>
  
      
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" md="6">
              <b-input-group prepend="IP Address" class="mb-3">
                <b-form-input class="" type="text" name="IP Address" placeholder="Required" v-validate="'required'" v-model="IP"/>
              </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-input-group prepend="Port Number" class="mb-3">
                <b-form-input class="" type="number" name="Port Number" v-validate="'required'" v-model="portNumber"/>
              </b-input-group>
            </b-col>
          </b-row>
  
      </b-container>
      <b-container v-if="assetType === 'Card Reader'">
      
          <b-col>
              <b-input-group prepend="Asset Name" class="mb-3">
                <b-form-input class="" type="text" name="Asset Name" placeholder="Required"  v-model="assetName"/>
              </b-input-group>
            </b-col>
            
      </b-container>
        
      
      <template #actions>
            <b-row class="flex-grow-1">
                <b-col cols="4">
                    <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="submit" >
                        Save change
                        <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                    </b-btn>
                </b-col>
                <b-col cols="4">
                    <b-btn variant="danger" block class="text-nowrap" :disabled="loading" @click="deleteAsset" >
                        Delete
                        <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                    </b-btn>
                </b-col>
                <b-col cols="4">
                    <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="hide" >
                        Cancel
                    </b-btn>
                </b-col>
            </b-row>
        </template>
      
      
      
    </CModal>
    
</template>
  
<script>

  import CModal from "../shared/Cmodal";
   
  export default {
      name:"editAssets",
      props:{
          show:{type:Boolean},
          item:{type:Object}
      },
      components:{
          CModal
      },
      data(){
        return{
          assetType:"",
          assetName:"",
          printerType:"",
          portNumber:9100,
          registrationCode:"",
          IP:'',
          err:'',
          loading:false,
          selectedReader:null,
          selectedPrinter:null,
          cardReaders:[],//to hold the names only for radio buttons
          thermalPrinters:[],
          referenceCardReaders:[],
          referenceTheremalPrinters:[],
          deletedPrinterLink:false,
          deletedReaderLink:false,
          assetLinks:[],
        }
      },
      watch:{
        item: function(newVal){
          
          if(newVal.AssetName != "" && newVal){
            this.loading = false
            this.assetType = this.item.AssetCategory
            
            if(this.assetType === "Self-Ordering Kiosk" || this.assetType === "POS Terminal Display"){
              
              this.loading = true
              
              
              

              this.$api.asset.Get({RestaurantID:localStorage.getItem('selectedRestaurant'),AssetCategory:'Thermal Printer'}).then(res=>{
                
                this.referenceTheremalPrinters = res.data.RestaurantAssets
                
                this.referenceTheremalPrinters.forEach(el=>{
                  
                  this.thermalPrinters.push(el.AssetName) 
                
                  if(el.RestaurantPrinter.IKey === this.item.KioskPrinterID){
                    this.selectedPrinter = el.AssetName
                  }
                })
              }).catch(()=>{this.loading = false})
              
              this.$api.asset.Get({RestaurantID:localStorage.getItem('selectedRestaurant'),AssetCategory:'Card Reader'}).then(res=>{
                
                this.referenceCardReaders = res.data.RestaurantAssets
                
                this.referenceCardReaders.forEach(el=>{
            
                  this.cardReaders.push(el.AssetName) 
            
                  if(el.RestaurantPOS.IKey === this.item.KioskPOSID){
                    this.selectedReader = el.AssetName
                  }

                })
                

              }).catch(()=>{this.loading = false})
              


            }


            this.assetName = this.item.AssetName
            this.IP = this.item.IPAddress
            if(this.assetType === "Thermal Printer"){
              this.portNumber = this.item.RestaurantPrinter.Port
              if(this.item.RestaurantPrinter.PrintTaskID === 1){
                this.printerType = 'Order Ticket'
              }else{
                this.printerType = 'Customer Receipt'

              }
            }
            this.loading = false
            
            
          }
          

          
        }
      },
      methods:{

        printerLinkChanged(){
          this.deletedPrinterLink = false
        },
        readerLinkChanged(){
          this.deletedReaderLink = false
        },

        printerSelectNone(){
          this.deletedPrinterLink = true
          this.selectedPrinter = null
        },
        readerSelectNone(){
          this.deletedReaderLink = true
          this.selectedReader = null
        },

        deleteAsset(){

          this.$api.asset.DeleteLink({RestaurantID:parseInt(localStorage.getItem('selectedRestaurant')),Ikey:this.item.IKey})
          .catch(()=>{this.$showError("Error occurd while deleting asset link.")})
          this.$api.asset.Delete(this.item.IKey).then(res=>{
          //if(!res.success)//api doesn't respond with success but it works, if api is working remove the comment
            this.hide()
          }).catch(()=>{this.$showError("Error occurd while deleting asset.")})

        },
        
        changePrinterType(printerType){
          this.err = ""
          this.printerType = printerType
          
        },
        hide(){
          this.registrationCode = ""
          this.assetType ="Menu Display"
          this.assetName = ""
          this.printerType = ""
          this.portNumber = 9100
          this.IP = ""
          this.err = ""
          this.referenceCardReaders = []
          this.referenceTheremalPrinters = []
          this.cardReaders = []
          this.thermalPrinters = []
          this.selectedPrinter = null
          this.selectedReader = null
          this.deletedReaderLink = false
          this.deletedPrinterLink = false

          this.$emit('hideWindow')
        },
         isIpValid(IP) {
    
          const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/;
  
          return ipv4Regex.test(IP);
        },

        updateReaderTip(model, disable){
          const readerTipModel = {
            UserID: localStorage.getItem('userID'),
            RestaurantID: model.RestaurantID,
            POSIKey: model.PosID,
            ShowTipOnReader: disable ? 0 : 1
          }
          
          return this.$api.getRestaurant.UpdatePOSShowTipOnReader(readerTipModel)
          .catch(()=>{this.$showError("Error occurd while updating reader tip setting.")})
        },

        updateLinks(){

          if(this.selectedReader != null || this.selectedPrinter != null || this.deletedPrinterLink || this.deletedReaderLink){//update
                let model={
                  RestaurantID:parseInt(localStorage.getItem('selectedRestaurant')),
                  KioskID:this.item.IKey,
                  PosID:0,
                  PrinterID:0
                }
                if(this.deletedReaderLink){
                  const removedReaderIKey = this.item.KioskPOSID
                  model.PosID = 0
                  if(removedReaderIKey){
                    this.updateReaderTip({...model, PosID: removedReaderIKey}, false)
                  }
                }else if(this.selectedReader != null){
                  let reader = this.referenceCardReaders.find(el=> el.AssetName === this.selectedReader)
                  model.PosID = reader.RestaurantPOS.IKey
                  this.updateReaderTip(model, true)
                }
                  console.log("called")
                if(this.selectedPrinter != null){
                  console.log("called2")
                  if(this.deletedPrinterLink){
                    console.log("called3")
                    model.PrinterID = 0
                  }else{
                    
                    let printer = this.referenceTheremalPrinters.find(el=> el.AssetName === this.selectedPrinter)
                    model.PrinterID = printer.RestaurantPrinter.IKey
                  }
                }


                this.$api.asset.CreateAssetLink(model).catch(()=>{this.$showError("Error occurd while liking assets!")})
              }

        },



        submit(){
        let model = 
          {
            RestaurantID: localStorage.getItem('selectedRestaurant'),
            IKey:this.item.IKey,
            AssetName: "AssetName",
            AssetCategory: "AssetCategory",
            
            Printer: {
                PrinterIkey:0,
                PrinterName: "PrinterName",
                MAC: "MA",
                IPAddress: "IPAddress",
                PrintTaskID: 1,
                Port: 123
            },
            Pos: {
              POSIkey:0,
              POSName: "POSName",
              POSCode: "POSCode"
            },
            KDS:{
              KDSName:"KDSName",
              KDSIkey:0
            }
          }
          
        
          
          if(this.assetType === "Menu Display" || this.assetType === 'Kitchen Display (KDS)'){
            if(this.assetName === "")
              return this.err = "Asset Name is required"
            
            if( this.assetType === 'Kitchen Display (KDS)'){
              model.KDS.KDSName = this.assetName
              model.KDS.KDSIkey = this.item.RestaurantKDS.IKey
            }
            model.AssetCategory = this.assetType
            model.AssetName = this.assetName
            
            this.loading = true
            
            this.$api.asset.Update(model, this.item.IKey).then(res=>{
              this.loading = false
              if(res.message === "asset successfully updated") 
              this.hide()
            })
          }

          if(this.assetType === "Self-Ordering Kiosk" || this.assetType === "POS Terminal Display"){
            if(this.assetName === "")
              return this.err = "Asset Name is required"
            
            
            model.AssetCategory = this.assetType
            model.AssetName = this.assetName
            
            this.loading = true
            
            this.updateLinks()

            this.$api.asset.Update(model, this.item.IKey).then(res=>{
              this.loading = false
              if(res.message === "asset successfully updated") 
              this.hide()
            }).catch(()=>{this.$showError("Error occurd while updating asset.")})


          }

          if(this.assetType === "Card Reader"){
            if(this.assetName === "")
              return this.err = "Asset Name is required"
            
            model.Pos.POSIkey = this.item.RestaurantPOS.IKey
            model.Pos.POSName= this.assetName,
            model.AssetCategory = this.assetType
            model.AssetName = this.assetName
            
            
            this.loading = true
              
            this.$api.asset.Update(model, this.item.IKey).then(res => {
                this.loading = false
                if (res.message === "asset successfully updated") {
                    this.hide()
                } else {
                    this.err = "Something went Wrong!"
                }
            }).catch(() => {
                this.err = "Something went wrong!"
                this.loading = false
            })
          }
          if(this.assetType === "Thermal Printer"){
            if(this.assetName === "")
              return this.err = "Asset Name is required"
            
            if(!this.isIpValid(this.IP))
              return this.err = "Please Enter a valid IP address"
  
            if(this.IP === "")
              return this.err = "IP address is required"
            
            if(this.printerType === "")
              return this.err = "Please select what the printer is used for."
  
  
            model.AssetCategory = this.assetType
            model.AssetName = this.assetName
            
            model.Printer.IPAddress = this.IP
            model.IPAddress = this.IP
            
            model.Printer.PrinterIkey = this.item.RestaurantPrinter.IKey
            model.Printer.Port = this.portNumber
            model.Printer.PrinterName = this.assetName
            
            
            model.AssetType = "Printer"
            
            if(this.printerType === "Order Ticket")
              model.Printer.PrintTaskID = 1
            else
              model.Printer.PrintTaskID = 2
            
            
              this.$api.asset.Update(model, this.item.IKey).then(res => {
              this.loading = false
              if (res.message === "asset successfully updated") 
                  this.hide()
              else{
                
                if(res.message === "Duplicate information."){
                  this.err = "Name and IPAddress field must be unique."
                }
              }
              
            })
              
          }
  
  
  
          
  
          
        }
      }
  }
  </script>
  
  <style lang="css" scoped>
    input::placeholder{
      opacity: 0.5 !important;
    }
    .asset-type-btn{
      border-radius: 0 !important;
      border: 1px solid gray !important;
      height: 2rem !important;
      width: 12rem !important;
      color:  black !important;
    }
    .printer-type-btn{
      border-radius: 0 !important;
      border: 1px solid gray !important;
      height: 2rem !important;
      width: 10rem !important;
      color:  black !important;
    }
    
  
  </style>